import { z } from "zod";

export const otherInfoSchema = z.object({
  otherInfo: z.string(),
});
